import { Accordion, AccordionContent, AccordionItem, AccordionTrigger } from "@/components/ui/accordion";
import { SectionHeading, Reveal } from "@/components/Reveal";

const FAQS = [
  {
    q: "What type of plots do you offer?",
    a: "We showcase residential, commercial and investment-oriented plot opportunities.",
  },
  {
    q: "Where are your properties located?",
    a: "Our listings focus on locations around Nagpur, including areas near major connectivity corridors such as Samruddhi Mahamarg, Umred Road and Wardha Road.",
  },
  {
    q: "Can I schedule a site visit?",
    a: "Yes. Interested customers can contact us to enquire about site visits for available properties.",
  },
  {
    q: "Are the plots suitable for investment?",
    a: "Property suitability depends on the location, documentation, development potential and individual investment goals. Customers should independently verify all property details before making a decision.",
  },
  {
    q: "How can I enquire about a property?",
    a: "You can use the enquiry form, phone number or WhatsApp contact option.",
  },
];

export default function FAQ() {
  return (
    <section id="faq" data-testid="faq-section" className="py-24 lg:py-32">
      <div className="mx-auto max-w-4xl px-4 sm:px-6 lg:px-8">
        <SectionHeading
          chapter="08"
          eyebrow="Common Questions"
          title="Frequently Asked Questions"
        />
        <Reveal delay={0.15}>
          <Accordion type="single" collapsible className="mt-12" data-testid="faq-accordion">
            {FAQS.map((faq, i) => (
              <AccordionItem key={i} value={`item-${i}`} className="border-b border-navy/10">
                <AccordionTrigger
                  data-testid={`faq-question-${i}`}
                  className="py-6 text-left font-display text-lg font-semibold text-navy hover:text-gold-dark hover:no-underline"
                >
                  {faq.q}
                </AccordionTrigger>
                <AccordionContent className="pb-6 text-sm leading-relaxed text-muted-foreground md:text-base">
                  {faq.a}
                </AccordionContent>
              </AccordionItem>
            ))}
          </Accordion>
        </Reveal>
      </div>
    </section>
  );
}
